import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Formular-Beschriftung auf Basis von `.sec-label` (immer `htmlFor` setzen). */
export const Label = forwardRef(function Label({ className, ...rest }, ref) {
    return _jsx("label", { ref: ref, className: cn('sec-label', className), ...rest });
});
